// extracted by mini-css-extract-plugin
export var md = "_2m-4";
export var semantic = "_2m-5";
export var sm = "_2m-3";
export var text = "_2m-6";
export var toggleInput = "_2m-0";
export var toggleSwitch = "_2m-1";
export var xs = "_2m-2";